import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { cardButton, SanityCardButton } from './buttonRow';

export const SanityFeatureComparison = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('featureComparison'),
  _key: z.string(),
  theme: z.enum(['light', 'charcoal']),
  eyebrow: z.string().optional().nullable(),
  title: z.string(),
  description: SanityBasicText.optional().nullable(),
  buttons: z.array(SanityCardButton).optional().nullable(),
  headers: z.array(z.string()),
  rows: z.array(
    z.object({
      _key: z.string(),
      featureLabel: z.string(),
      featureContent: SanityBasicText.optional().nullable(),
      cells: z.array(
        z.object({
          _key: z.string(),
          isEmpty: z.boolean().optional().nullable(),
          icon: z.enum(['Checkmark', 'Dash']).optional().nullable(),
          label: z.string().optional().nullable(),
        }),
      ),
    }),
  ),
  footerButtons: z.array(SanityCardButton).optional().nullable(),
});
export type SanityFeatureComparison = z.infer<typeof SanityFeatureComparison>;

export const featureComparison = groq`{
  _type,
  _key,
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "light")),
  eyebrow,
  title,
  description[] ${basicText},
  buttons[] ${cardButton},
  headers,
  rows[] {
    _key,
    featureLabel,
    featureContent[] ${basicText},
    cells[] {
      _key,
      isEmpty,
      icon,
      label
    }
  },
  footerButtons[] ${cardButton},
}`;
